import { DirectorRemunerationStatus } from '@enums/director-remuneration-status.enum';
import { StatusColor } from '@enums/status-color.enum';

export const DIRECTOR_REMUNERATION_STATUS_COLOR: Record<DirectorRemunerationStatus, StatusColor> = {
  [DirectorRemunerationStatus.ignored]: StatusColor.grey4,
  [DirectorRemunerationStatus.done]: StatusColor.accent,
  [DirectorRemunerationStatus.readyToBeSent]: StatusColor.orange,
  [DirectorRemunerationStatus.sent]: StatusColor.accent,
  [DirectorRemunerationStatus.todo]: StatusColor.grey3,
  [DirectorRemunerationStatus.toCheck]: StatusColor.orange
};
